import { Button, Stack, Typography } from '@mui/material';
import { Image } from 'app/components';
import React from 'react';
import { useHistory } from 'react-router-dom';
const NotFound = () => {
    const history = useHistory();
    return (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
            height: '100vh',
            position: 'relative',
        } },
        React.createElement(Stack, { direction: 'row', justifyContent: 'center', sx: (theme) => ({
                maxWidth: '560px',
                marginLeft: 'auto',
                marginRight: 'auto',
                textAlign: 'center',
                paddingLeft: theme.spacing(4),
                paddingRight: theme.spacing(4),
                img: {
                    height: '360px',
                    paddingBottom: theme.spacing(8),
                },
            }) },
            React.createElement(Image, { name: 'error-404.svg', alt: 'error-404' })),
        React.createElement(Stack, { direction: 'column', alignItems: 'center', spacing: 2, sx: (theme) => ({
                maxWidth: '560px',
                marginLeft: 'auto',
                marginRight: 'auto',
                textAlign: 'center',
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3),
                '.MuiButton-root': {
                    padding: theme.spacing(2, 3),
                },
                '.MuiTypography-body2': {
                    fontSize: '14px',
                    color: theme.palette.text.secondary,
                },
            }) },
            React.createElement(Typography, { variant: 'h4' }, "\u041E\u0439, \u043F\u043E\u0447\u0435\u043C\u0443 \u0432\u044B \u0437\u0434\u0435\u0441\u044C?"),
            React.createElement(Typography, { variant: 'body2' }, "\u041F\u0440\u0438\u043D\u043E\u0441\u0438\u043C \u0438\u0437\u0432\u0438\u043D\u0435\u043D\u0438\u044F \u0437\u0430 \u043D\u0435\u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430. \u041F\u043E\u0445\u043E\u0436\u0435, \u0432\u044B \u043F\u044B\u0442\u0430\u0435\u0442\u0435\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0438\u043B\u0438 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043E\u0432\u0430\u043B\u0430."),
            React.createElement(Button, { size: 'large', color: 'primary', variant: 'contained', onClick: history.goBack, disableElevation: true }, "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434"))));
};
export default NotFound;
